import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { createWhitelistFilter } from 'redux-persist-transform-filter';
import rootReducer from './rootReducer';
import { decode, encode } from 'utils/crypto/crypto';

// midlewares
const midlewares = [thunk];

const encryptorTransform = createTransform(
	// Encrypt state before persisting
	(inboundState) => encode(JSON.stringify(inboundState)),
	// Decrypt state before retrieving
	(outboundState) => JSON.parse(decode(outboundState))
);

const whiteListFilterSession = createWhitelistFilter('session', [
	'isLoginSuccessful',
	'authenticated',
	'authorized',
	'showWelcomeModal',
	'login',
	'user',
	'isWeakPassword',
	'errorMessage',
]);

const whiteListFilterSettings = createWhitelistFilter('settings', ['language', 'cookies', 'remoteConfig']);

const whiteListPaymentType = createWhitelistFilter('paymentType', ['action']);

export const persistConfig = {
	key: 'omantelAppRoot',
	storage,
	whitelist: ['session', 'settings', 'paymentType', 'bills', 'timestamp', 'dynamicLabels'],
	transforms: [whiteListFilterSession, whiteListFilterSettings, whiteListPaymentType, encryptorTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// final store
export const store = createStore(
	persistedReducer,
	compose(
		applyMiddleware(...midlewares),
		window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : compose
	)
);

export const persistor = persistStore(store);

// dispatcher
export const dispatch = (action) => {
	return store.dispatch(action);
};

export default store;
